const BRAND_ID = 5898

const PIMCORE_URL = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
    'https://headless.inmusicbrands.com' :
    'https://staging.headless.inmusicbrands.com'

const SUITE_CRM_URL = 'https://crmtool.inmusicbrands.com'
const RECAPTCHA_KEY = '6LdPO7kZAAAAABGiIAZYVXsusLHXWuCCvJBJG5YU'

const ENDPOINTS = {
    GET_CART_ID: (iso) => `/api/${iso.toLowerCase()}/get_cart_id?brand_id=${BRAND_ID}`,
    ADD_TO_CART: (iso) => `/api/${iso.toLowerCase()}/add_to_cart`,
    REMOVE_FROM_CART: `/api/remove_from_cart`,
    GET_CART: (iso) => `/api/${iso.toLowerCase()}/get_cart`,
    CATEGORY: `/api/get_categories?brand_id=${BRAND_ID}`,
    PRODUCT: `/api/get_products?product_type=software`,
    PRICE: `/api/get_prices?product_type=software&brand_id=${BRAND_ID}`,
    PROMOTION: `/api/get_promotions`,
    COUNTRY: `/api/pim/countries`,
    HOMEPAGE: `/api/homepage/${BRAND_ID}`,
    REDEEM_VOUCHER: (iso) => `/api/${iso.toLowerCase()}/redeem-voucher`,
    ROLLBACK_VOUCHER: (iso) => `/api/${iso.toLowerCase()}/rollback-redemption`,
    REGISTER_PRODUCT: (iso) => `/api/${iso.toLowerCase()}/register-product`,
}

const ESW_CLASSNAMES = {
    CART_PRICE: 'esw-cart-price',
    CART_ITEM: 'esw-cart-item',
    CARTITEM_QUANTITY: 'esw-cartitem-quantity',
    CARTITEM_SUBTOTAL: 'esw-cartitem-subtotal',
    CART_SUBTOTAL: 'esw-cart-subtotal',
    CART_SUBTOTAL_BEFORE_DISCOUNT: 'esw-cart-subtotal-before-discount',
    CART_TOTAL: 'esw-cart-total',
    PAGE_PRICE: 'esw-page-price',
    DISCOUNT_ITEM: 'esw-discount-item',
    CHECKOUT_BUTTON: 'esw-checkout-btn',
    RETURNS_BUTTON: 'esw-returns-btn',
    RETURNS_DROPDOWN: 'esw-returns-dropdown-btn',
    RETURNS_LEADING_TEXT: 'esw-returns-leading-text',
    COUNTRY_RETURNS_PORTAL: 'esw-country-returns-portal',
    COUNTRY_RETURNS_CUSTOM: 'esw-custom-country-returns',
}

const BASE_COUNTRY_ISO = 'DE'
const FLAG_URL = 'https://flagcdn.com'
const GET_FLAG_URL = iso => `${FLAG_URL}/${iso?.toLowerCase()}.svg`

module.exports = {
    BRAND_ID,
    PIMCORE_URL,
    SUITE_CRM_URL,
    RECAPTCHA_KEY,
    ENDPOINTS,
    ESW_CLASSNAMES,
    BASE_COUNTRY_ISO,
    GET_FLAG_URL,
}
